<button mat-fab color="primary" type="button" aria-label="Back to top of page" class="back-to-top-button"
  [@appearInOut]="animationState" (click)="scrollTop($event)">
  <app-font-icon iconType="remix" iconName="arrow-up-s-line" iconSize="custom" iconColor="#06586c">
</app-font-icon>
</button>